import { FunctionComponent } from 'preact';
import { useDispatch, useSelector } from 'react-redux';
import { CirclePlayPauseButton } from '../../../circlePlayPauseButton/circlePlayPauseButton';
import { useStyles } from '../../../../../common/hooks/useStyles';
import { getExtraSmallControlsStyleObject } from './extraSmallControls.style';
import { playerDataSelector } from '../../../../../common/store/selectors/playerData.selector';
import { CONTROLS_ICON_TYPES } from '../../../icon/iconMapper';
import { Icon } from '../../../../../common/components/icon/icon';
import {
  setAdMute,
  setUserInteraction
} from '../../../store/controlsPlugin.actions';
import { UserInteractionTypes } from '../../../../../common/store/store.types';
import { playerSettingsSelector } from '../../../../../common/store/selectors/playerSettings.selector';
import { adsDataSelector } from '../../../../../common/store/selectors/adsData.selector';
import { css } from '../../../../../common/styles/styles.utils';
import {
  getFullscreenCircleId,
  getMuteCircleId,
  getUnmuteCircleId
} from '../../../htmlElements/htmlElementsIdGetter';
import { setMute, setFullscreen } from '../../../../../core/store/playerData/playerDataSlice';

export const ExtraSmallControls: FunctionComponent = () => {
  const dispatch = useDispatch();
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqueId);
  const showControls = useSelector(playerDataSelector.showControls);
  const contentMuted = useSelector(playerSettingsSelector.muted);
  const adMuted = useSelector(adsDataSelector.adMuted);
  const isVastAd = useSelector(adsDataSelector.isVastAd);
  const adBreak = useSelector(adsDataSelector.adBreak);

  const styles = useStyles(getExtraSmallControlsStyleObject, [showControls]);
  const { controlsWrapperStyle, controlsContainerStyle, iconStyle } = styles;

  const showAdControls = isVastAd && adBreak;
  const muted = showAdControls ? adMuted : contentMuted;
  const setMuteAction = showAdControls ? setAdMute : setMute;

  const updateUserInteraction = (newMuteState: boolean): void => {
    if (!showAdControls) {
      dispatch(setUserInteraction(newMuteState ? 'mute' : 'unmute'));
    }
  };

  const onClickVolumeButton = (): void => {
    const newMuteState = !muted;
    dispatch(setMuteAction(newMuteState));
    updateUserInteraction(newMuteState);
  };

  const onFullscreenClicked = (e: MouseEvent): void => {
    e.stopPropagation();
    dispatch(setFullscreen('enter'));
    dispatch(setUserInteraction('enterFullscreen' as UserInteractionTypes));
  };

  return (
    <div style={controlsWrapperStyle}>
      <div style={controlsContainerStyle}>
        <Icon
          icon={CONTROLS_ICON_TYPES.FULLSCREEN_XS_BLUR}
          onClick={onFullscreenClicked}
          style={css(iconStyle)}
          id={getFullscreenCircleId(playerUniqueId)}
        />
        <CirclePlayPauseButton />
        <Icon
          icon={muted ? CONTROLS_ICON_TYPES.VOLUME_MUTE_XS_BLUR : CONTROLS_ICON_TYPES.VOLUME_UNMUTE_XS_BLUR}
          onClick={onClickVolumeButton}
          style={css(iconStyle)}
          id={muted ? getMuteCircleId(playerUniqueId) : getUnmuteCircleId(playerUniqueId)}
        />
      </div>
    </div>
  );
};
